const Footer = ()=>{
    return(
        <>
            <p>discourse | 2023 | Co.lab cohort16</p>
        </>
    )
}
export default Footer